import * as Components from './EditorComponents'
export class EditorComponentsBuilder {
  constructor(innerComponents = false, pageComponents = false) {
    this.innerComponents = innerComponents
    this.pageComponents = pageComponents
  }

  buildComponents() {
    return Object.keys(Components).map(component => new Components[component])
  }

  get() {
    if (this.pageComponents) {
      return this.getPageComponents()
    }

    if (this.innerComponents) {
      return this.getInnerComponents()
    }

    return this.getComponents()
  }

  getComponents() {
    return this.buildComponents()
      .filter(component => ! component.pageComponent)
      .map(component => component.info())
  }

  getPageComponents() {
    return this.buildComponents()
      .filter(component => component.pageComponent)
      .map(component => component.info())
  }

  getInnerComponents() {
    return this.buildComponents()
      .filter(component => component.innerComponent)
      .filter(component => ! component.pageComponent)
      .map(component => component.info())
  }

  create(component, variation = 'Primary') {
    return (new Components[component]).create(variation)
  }
}